import { render, staticRenderFns } from "./CollegeScoreOther.vue?vue&type=template&id=76196a72&scoped=true"
import script from "./CollegeScoreOther.vue?vue&type=script&lang=js"
export * from "./CollegeScoreOther.vue?vue&type=script&lang=js"
import style0 from "./CollegeScoreOther.vue?vue&type=style&index=0&id=76196a72&prod&scoped=true&lang=less"
import style1 from "./CollegeScoreOther.vue?vue&type=style&index=1&id=76196a72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76196a72",
  null
  
)

export default component.exports